/*
 * @param date
 * @param timezone
 * @returns same date if its not a weekeend,  or the following working day
 */
import moment from 'moment-timezone';

const WEEKEND_DAYS = [6, 7];
const SATURDAY = 6;

const getNonWeekendDay = ({ date, timezone = moment.tz.guess() }) => {
  const momentDate = moment(date).tz(timezone);
  const weekDay = momentDate.isoWeekday();
  if (WEEKEND_DAYS.includes(weekDay)) {
    momentDate.add(weekDay === SATURDAY ? 2 : 1, 'day');
  }
  return momentDate;
};

export default getNonWeekendDay;
